






















import {
  computed,
  ComputedRef,
  defineComponent,
  ref,
  watch
} from '@vue/composition-api';
import Store from '@/store/index';
import BannerCard from '@/components/molecules/contents-card/BannerCard.vue';
import SectionNavigator from '@/components/molecules/navigators/SectionNavigator.vue';
import {
  nextBtnState,
  SectionHelperService
} from '@/services/home/section.helper';
import { IconType } from '@/commons/constants/icon-types';
import { Element, Section } from '@/models';

export default defineComponent({
  name: 'BannerSwipeSection',
  components: {
    BannerCard,
    SectionNavigator
  },
  props: {
    section: Object
  },
  setup(props) {
    const sectionInfo: ComputedRef<Section> = computed(
      () => props.section as Section
    );
    const elementUiType = computed(() => sectionInfo.value.elementUiType);
    const elements: ComputedRef<Element[]> = computed(() =>
      sectionInfo.value && sectionInfo.value.elements
        ? sectionInfo.value.elements
        : []
    );
    const MAX_SLIDE_LEN = SectionHelperService.getSectionMaxLen(
      elementUiType.value
    );
    const liWidth = SectionHelperService.getLiWidth(
      sectionInfo.value.elementUiType
    );
    const divRef: any = ref(null);
    let currentIndex = 1;
    let currentX = 0;
    let value = Math.floor(elements.value.length / MAX_SLIDE_LEN);
    let namoji = Math.floor(elements.value.length % MAX_SLIDE_LEN);
    const prev = ref(false);
    const next = ref(nextBtnState(value, namoji));

    const resetIndex = () => {
      try {
        currentIndex = 1;
        currentX = 0;
        value = Math.floor(elements.value.length / MAX_SLIDE_LEN);
        namoji = Math.floor(elements.value.length % MAX_SLIDE_LEN);
        prev.value = false;
        next.value = nextBtnState(value, namoji);
        divRef.value.style.transform = `translateX(0px)`;
      } catch (e) {
        //
      }
    };

    const sendDirection = ({ type }: IconType) => {
      if (type.toLowerCase() === 'prev') {
        gotoPrev();
      } else {
        gotoNext();
      }
    };

    const gotoPrev = () => {
      if (currentIndex > 1) {
        currentX = currentX - MAX_SLIDE_LEN * liWidth;
        divRef.value.style.transform = `translateX(-${currentX}px)`;
        currentIndex = currentIndex - 1;
        next.value = true;
        prev.value = currentX !== 0;
      } else {
        if (namoji > 0) {
          currentX = currentX - namoji * liWidth;
          divRef.value.style.transform = `translateX(-${currentX}px)`;
          next.value = true;
        }
        prev.value = false;
      }
    };

    const gotoNext = () => {
      if (currentIndex === value) {
        if (namoji > 0) {
          currentX = currentX + namoji * liWidth;
          divRef.value.style.transform = `translateX(-${currentX}px)`;
          prev.value = true;
        }
        next.value = false;
      } else {
        currentIndex = currentIndex + 1;
        currentX = currentX + MAX_SLIDE_LEN * liWidth;
        divRef.value.style.transform = `translateX(-${currentX}px)`;
        prev.value = true;
        next.value = !(namoji === 0 && currentIndex === value);
      }
    };

    watch(elements, () => {
      resetIndex();
    });

    return {
      elements,
      divRef,
      next,
      prev,
      sendDirection
    };
  }
});
